import apiClient from '../services/apiClient';
import type { ApiResponse, PaginatedResponse, NcfType, NcfSequence } from '../types/api';

export type { NcfType, NcfSequence } from '../types/api';

export interface CreateNcfSequenceRequest {
  ncf_type_id: number;
  authorization_number: string;
  prefix: string;
  start_number: number;
  end_number: number;
  valid_from: string;
  valid_until: string;
}

export interface UpdateNcfSequenceRequest {
  authorization_number?: string;
  valid_from?: string;
  valid_until?: string;
  is_active?: boolean;
}

const NCF_TYPES_URL = '/ncf-types';
const NCF_SEQUENCES_URL = '/ncf-sequences';

export const ncfTypeService = {
  async getActive(): Promise<NcfType[]> {
    const response = await apiClient.get<ApiResponse<NcfType[]>>(NCF_TYPES_URL);
    return response.data.data;
  },
};

export const ncfSequenceService = {
  async getAll(params: Record<string, string | number | boolean> = {}): Promise<PaginatedResponse<NcfSequence>> {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== '') q.set(k, String(v)); });
    const response = await apiClient.get<PaginatedResponse<NcfSequence>>(`${NCF_SEQUENCES_URL}?${q.toString()}`);
    return response.data;
  },

  async getById(id: number): Promise<NcfSequence> {
    const response = await apiClient.get<ApiResponse<NcfSequence>>(`${NCF_SEQUENCES_URL}/${id}`);
    return response.data.data;
  },

  async create(data: CreateNcfSequenceRequest): Promise<NcfSequence> {
    const response = await apiClient.post<ApiResponse<NcfSequence>>(NCF_SEQUENCES_URL, data);
    return response.data.data;
  },

  async update(id: number, data: UpdateNcfSequenceRequest): Promise<NcfSequence> {
    const response = await apiClient.put<ApiResponse<NcfSequence>>(`${NCF_SEQUENCES_URL}/${id}`, data);
    return response.data.data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${NCF_SEQUENCES_URL}/${id}`);
  },

  async toggleActive(id: number): Promise<NcfSequence> {
    const response = await apiClient.patch<ApiResponse<NcfSequence>>(`${NCF_SEQUENCES_URL}/${id}/toggle-active`);
    return response.data.data;
  },
};
